import { Colors } from "@/enums/Colors";
import { Box, BoxProps, styled } from "@mui/material";
import { LazoLogo } from "../drawer-components/LazoLogo";
import LazoPurpleBackground from "../utils/LazoPurpleBackground";
import ConnectAccounting from "./ConnectAccounting";
import ConnectingAccounting from "./ConnectingAccounting";

type Props = Omit<BoxProps, "children"> & {
  open: boolean;
  isFetching?: boolean;
};

const BlurredBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100%",
  width: "100%",
  backgroundColor: Colors.PURPLE_AA5FEF,
  borderRadius: "1rem",
});

const ContentBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  height: "100%",
  width: "100%",
  gap: ".75rem",
  justifyContent: "space-evenly",
  alignItems: "center",
});

export default function ConnectAccountingModal(props: Props) {
  if (!props.open) {
    return null;
  }

  return (
    <BlurredBox>
      <LazoPurpleBackground width={"100%"} showLogo={false} />
      <ContentBox>
        <LazoLogo
          imgStyle={{
            filter: "brightness(100)",
          }}
          containerSxProps={{ paddingTop: "2.5rem" }}
          imageWidth={"170px"}
        />
        <ContentBox sx={{ height: "100%" }}>{props.isFetching ? <ConnectingAccounting /> : <ConnectAccounting />}</ContentBox>
      </ContentBox>
    </BlurredBox>
  );
}
